import Keyboard from "react-simple-keyboard";
import { TecladoAlfanumericoContainer } from "./localStyle";
import "react-simple-keyboard/build/css/index.css";
const TecladoAlfanumerico = ({
  onChange,
  onEnter,
  maxLength,
  sinNumeros,
  enterStr,
  modeLight,
  onDelete,
  onKey,
}) => {
  const onKeyPress = (button) => {
    if (button === "{enter}") return onEnter && onEnter();
    if (button === "{bksp}") return onDelete && onDelete();
    if (onKey) onKey(button);
  };

  const defaultLayout = [
    "1 2 3 4 5 6 7 8 9 0  ",
    "Q W E R T Y U I O P  ",
    "A S D F G H J K L Ñ {bksp}",
    "Z X C V B N M {space} {enter}",
  ];
  const layoutSinNumeros = [
    "Q W E R T Y U I O P ",
    "A S D F G H J K L Ñ {bksp}",
    "Z X C V B N M {space} {enter}",
  ];

  return (
    <TecladoAlfanumericoContainer modeLight={modeLight} sinNumeros={sinNumeros}>
      <Keyboard
        maxLength={maxLength}
        layoutName={"default"}
        onChange={onChange}
        theme={"hg-theme-default myTheme1"}
        onKeyPress={onKeyPress}
        layout={{
          default: sinNumeros ? layoutSinNumeros : defaultLayout,
        }}
        display={{
          "{enter}": enterStr,
          "{escape}": "esc ⎋",
          "{space}": "Espacio",
          "{bksp}": "Borrar",
        }}
        buttonTheme={[
          {
            class: modeLight ? "hg-white" : "hg-latex10",
            buttons:
              "1 2 3 4 5 6 7 8 9 0 Q W E R T Y U I O P A S D F G H J K L Ñ Z X C V B N M",
          },
          {
            class: "hg-broccoli",
            buttons: "{enter}",
          },
          {
            class: "hg-danger",
            buttons: "{bksp}",
          },
          {
            class: "hg-space",
            buttons: "{space}",
          },
          {
            class: "hg-empty",
            buttons: " ",
          },
        ]}
      />
    </TecladoAlfanumericoContainer>
  );
};

export default TecladoAlfanumerico;
